<template>
  <div class="SelectTags">
    <v-select
      v-model="values"
      :items="banksTags"
      item-text="name"
      item-value="id"
      multiple
      :label="readOnly ? 'Тег (только чтение)' : 'Тег'"
      :readonly="readOnly"
    />
  </div>
</template>
<script>
export default {
  name: "SelectTags",
  components: {},
  data: () => ({}),
  props: {
    value: { type: Array, default: ()=>[]},
    readOnly: {type: Boolean, default: false}
  },
  methods: {
    async init() {
      await this.$store.dispatch("GetBanksTags");
    },
  },
  computed: {
    values: {
      get(){return this.value},
      set(val){this.$emit('input',val)}
    },
    banksTags() {
      return this.$store.getters.getBanksTags;
    },
  },
  async mounted() {
    await this.init();
  },
};
</script>
<style lang="sass" scoped>
</style>
